import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";

const ScrollWrapper = ({ children }) => {
  const location = useLocation();

  //scroll to top on page change
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  return children;
};

export default ScrollWrapper;
